"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkPreviewCard = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var BASE_CLASS_NAME = "link-preview-card";
var LinkPreviewCard = (0, mobx_react_1.observer)(function (props) {
    var _a = __read((0, react_1.useState)(false), 2), isHovering = _a[0], setIsHovering = _a[1];
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: BASE_CLASS_NAME, onMouseEnter: function () { return props.clickable && setIsHovering(true); }, onMouseLeave: function () { return props.clickable && setIsHovering(false); } },
        react_1.default.createElement("div", { style: {
                backgroundImage: "url(".concat(props.imageUrl, ")"),
            }, className: "".concat(BASE_CLASS_NAME, "__background"), onClick: function (event) {
                if (props.clickable) {
                    props.handleOnClick(event);
                }
            } }, props.clickable && (react_1.default.createElement(LinkPreviewCardButtonOverlay, { isHovering: isHovering, handleOnClick: props.handleOnClick })))));
});
exports.LinkPreviewCard = LinkPreviewCard;
var LinkPreviewCardButtonOverlay = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var isHovering = _a.isHovering, handleOnClick = _a.handleOnClick;
    return (react_1.default.createElement("div", { onClick: handleOnClick, className: (0, classnames_1.default)("".concat(BASE_CLASS_NAME, "__overlay"), (_b = {},
            _b["".concat(BASE_CLASS_NAME, "__overlay--is-current")] = isHovering,
            _b)) },
        react_1.default.createElement(kaleidoscope_2.Button, { type: kaleidoscope_3.ButtonType.Secondary }, "Change image preview")));
});
